export const COLORS = {
    PRIMARY : "rgb(32, 189, 89)",
    PRIMARY_LIGHT : "rgba(32, 189, 89,0.2)"
}